import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import styles from './NotiModal.module.css';

interface NotiModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
}

export const NotiModal: React.FC<NotiModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Xác nhận',
  message = 'Bạn có chắc chắn muốn thực hiện hành động này?',
  confirmText = 'Xác nhận',
  cancelText = 'Hủy'
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className={styles.notiModal} onClick={onClose}>
      <div className={styles.notiModalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.notiModalIcon}>
          <ExclamationCircleOutlined />
        </div>
        <div className={styles.notiModalTitle}>
          {title}
        </div>
        <div className={styles.notiModalMessage}>
          {message}
        </div>
        <div className={styles.notiModalActions}>
          <button
            className={`${styles.notiModalButton} ${styles.notiModalButtonCancel}`}
            onClick={onClose}
          >
            {cancelText}
          </button>
          <button
            className={`${styles.notiModalButton} ${styles.notiModalButtonConfirm}`}
            onClick={handleConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}; 